module.exports = __webpack_public_path__ + "media/application/images/section_images/services-04c77c5a67dfc59fa60c6be811000d02.jpg";